import { Controller } from "@hotwired/stimulus"
import { turboFetchForm } from "../util/common"

// Connects to data-controller="tracked-link-preview"
export default class extends Controller {
  static targets = ["blur"]
  static values = {
    previewUrl: String
  }

  connect() {
    this.updateTrackedLinkPreview = this.updateTrackedLinkPreview.bind(this)

    this.blurTargets.forEach(input => {
      input.addEventListener("blur", this.updateTrackedLinkPreview)
    })

    this.element.addEventListener("tags-input:added", this.updateTrackedLinkPreview)
    this.element.addEventListener("tags-input:deleted", this.updateTrackedLinkPreview)
    this.element.addEventListener("community-space-select:changed", this.updateTrackedLinkPreview)
  }

  disconnect() {
    this.blurTargets.forEach(input => {
      input.removeEventListener("blur", this.updateTrackedLinkPreview)
    })

    this.element.removeEventListener("tags-input:added", this.updateTrackedLinkPreview)
    this.element.removeEventListener("tags-input:deleted", this.updateTrackedLinkPreview)
    this.element.removeEventListener("community-space-select:changed", this.updateTrackedLinkPreview)
  }

  updateTrackedLinkPreview() {
    if (this.previewUrlValue) {
      turboFetchForm(this.previewUrlValue, this.element)
    }
  }
}
